import * as React from 'react';
export const TransitTooltipContext = React.createContext({ isTransitTariff: false });
